module.exports = __webpack_public_path__ + "static/media/kun-7.jpeg";